export default __webpack_public_path__ + "static/media/kebab.2ce42176.png";